import Cookies from "js-cookie";
import React, { createContext, useContext, useState } from "react";
import { User } from "../models/User";

interface AuthContextInterface {
  loggedUser?: User;
  token?: string;
  userChecked?: string;
  setLoggedUser: React.Dispatch<React.SetStateAction<User | undefined>>;
  setToken: React.Dispatch<React.SetStateAction<string | undefined>>;
  setUserChecked: React.Dispatch<React.SetStateAction<string | undefined>>;
  newNotifications?: number;
  setNewNotifications: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const AuthContext = createContext<AuthContextInterface>({} as AuthContextInterface);

export const AuthProvider = ({ children }: React.PropsWithChildren) => {
  const tokenCookie = Cookies.get(window.__env.AUTH_TOKEN_NAME || "alida-token");
  const userCheckedCookie = Cookies.get(window.__env.AUTH_USER_CHECKED_NAME || "alida-user-checked");
  const [loggedUser, setLoggedUser] = useState<User>();
  const [token, setToken] = useState<string | undefined>(tokenCookie);
  const [userChecked, setUserChecked] = useState<string | undefined>(userCheckedCookie);
  const [newNotifications, setNewNotifications] = useState<number | undefined>();

  return (
    <AuthContext.Provider value={{
      loggedUser, token, setLoggedUser, setToken,
      userChecked, setUserChecked,
      newNotifications, setNewNotifications,
    }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);
